/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import ForgotPassword from './ForgotPassword';

const title = 'Forgot Password';

export default {
  path: '/forgotPassword',

  action({ store }) {
    const { auth } = store.getState();
    if (auth.isAuth) {
      return { redirect: '/' };
    }
    return {
      title,
      chunks: ['forgotPassword'],
      component: <ForgotPassword title={title} />,
    };
  },
};
